import styled from "styled-components";
import { TableContainer, TableHead } from "@mui/material";

export const StyledTableWrapper = styled.div`
  width: 100%;
  font: normal normal medium 16px/22px Open Sans;
  color: #000000;
  opacity: 1;
  margin-top: ${({ mt }) => {
    return mt ? mt : "10px";
  }};
`;

export const HeaderCellStyle = styled.div`
  color: #000000;
  font-size: 16px;
  font-family: "Roboto", sans-serif;
`;

export const Data = styled.div`
  color: ${({ theme }) => {
    return theme.colors.title;
  }};
  font: normal normal normal 16px/22px Open Sans;
`;

export const EligibleModuleWrapper = styled.div`
  display: flex;
`;

export const StyledTableContainer = styled(TableContainer)`
  ::-webkit-scrollbar {
    width: 5px;
  };
  max-height: 390px;
`;

export const StyledTableHead = styled(TableHead)`
  & .MuiTableCell-head {
    background-color: rgb(247, 247, 247);
  }
`;